import { DEFAULT_FIELDS } from 'schemas/default-fields';
import { DATASOURCE, FIELD_TYPE, Schema } from 'schemas/types';

export const schema: Schema = {
  dataSource: DATASOURCE.ATTIVO,
  dataSourceId: 'Attivo',
  dataSourceVendor: 'Attivo',
  dataSourceLabel: 'Attivo',
  fields: {
    ...DEFAULT_FIELDS,
    'event.details': {
      label: 'Event Details',
      type: FIELD_TYPE.EVENT_DETAILS,
      description: 'Event additional details',
      notSearchable: true,
      width: 900, // (160 + 20) x 5
      relatedFields: [],
    },
  },
  summaryFieldIds: ['event.type'],
};
